import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IKpiIdSnapshotsMap, IKpiSnapshot } from "@gtmhub/kpis";
import { QueryParams } from "@webapp/core/abstracts/models/query-params.model";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { KpiSnapshotDTO } from "@webapp/kpis/models/kpi-snapshot.models";
import { KpiSnapshotsApiService } from "./kpi-snapshots-api.service";
import { KpiSnapshotsState } from "./kpi-snapshots-state.service";

@Injectable({
  providedIn: "any",
})
export class KpiSnapshotsFacade extends BaseFacade<IKpiSnapshot, KpiSnapshotDTO, KpiSnapshotsState, KpiSnapshotsApiService> {
  constructor(state: KpiSnapshotsState, api: KpiSnapshotsApiService) {
    super(state, api);
  }

  public getKpiSnapshots$(kpiId: string, queryParams?: QueryParams): Observable<IKpiIdSnapshotsMap> {
    return this.getAll$<IKpiIdSnapshotsMap>(
      { filter: { _id: { $in: [kpiId] } } },
      {
        ...new RequestConfig(),
        url: this.apiService.getGetKpisSnapshotsEndpoint(),
        queryParams: queryParams,
      }
    );
  }

  public createKpiSnapshot$(kpiId: string, payload: KpiSnapshotDTO): Observable<IKpiSnapshot> {
    return this.post$(payload, {
      ...new RequestConfig(),
      url: this.apiService.getCreateKpiSnapshotEndpoint(kpiId),
    });
  }
}
